import Button from 'assets/components/button/Button';
import LinkButton from 'assets/components/button/LinkButton';
import ThemeButtonLink from 'assets/components/button/themes/Theme.Button.Link';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import {
  getFileExtensionFromFileName,
  isImageExtension,
  isValidValue,
} from 'assets/utils/parsersAndValidation/Validators';

type PreviewDocument = {
  id: number;
  name: string;
  url?: string;
  extension?: string;
  description?: string;
  documentName?: string;
  inoviceNumber?: string;
  invoiceDate?: string;
  approved?: boolean;
  mimeType?: string;
  storedFilename?: string;
  documentType: string;
  onDelete?(): void;
};
type Props = {
  documents: PreviewDocument[];
  children?: any;
  isDownloadDisabled?: boolean;
  isDeleteDisabled?: boolean;
  showGallery?: boolean;
};
export default function ClaimDocumentPreview(props: Props) {
  const { lang } = getLocales();
  const hasInovices = props.documents?.some((it) => it.invoiceDate || it.inoviceNumber);
  const hasDocumentName = props.documents?.some((it) => it.documentName);

  return (
    <>
      {props.children}
      {!props.documents?.length ? (
        <ErrorWrapper children={lang.noFiles} />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <table className={ThemeTableSimple}>
            <thead>
              <tr>
                <th>{lang.fileName}</th>
                {hasDocumentName && <th>{lang.documentName}</th>}
                {hasInovices && (
                  <>
                    <th>{lang.invoiceNumber}</th>
                    <th>{lang.invoiceDate}</th>
                  </>
                )}
                <th>{lang.documentType}</th>
                <th>{lang.notes}</th>
                <th>{lang.actions}</th>
              </tr>
            </thead>
            <tbody>
              <DataMap
                data={props.documents}
                render={({ data: doc, index }) => (
                  <tr key={doc.id ?? `index-${index}`}>
                    <td>
                      {doc.name}
                      &nbsp;
                      {isValidValue(doc.approved) && !!doc.url && (
                        <Icon
                          style={{
                            color: doc.approved ? Theme.Color.success : Theme.Color.error,
                          }}
                          class={doc.approved ? 'fas-check' : 'fas-times'}
                        />
                      )}
                    </td>
                    {hasDocumentName && (
                      <>
                        <td>{doc.documentName}</td>
                      </>
                    )}
                    {hasInovices && (
                      <>
                        <td>{doc.inoviceNumber}</td>
                        <td>{doc.invoiceDate}</td>
                      </>
                    )}
                    <td>
                      {isImageExtension(doc.extension ?? getFileExtensionFromFileName(doc.name)) ||
                      doc.mimeType?.startsWith('image')
                        ? 'Image'
                        : doc.documentType}
                    </td>
                    <td>{doc.description ?? lang.noNotes}</td>
                    <td>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <LinkButton
                          class={ThemeButtonLink}
                          url={doc?.url}
                          target="_blank"
                          disabled={!doc.id || !doc.url || props.isDownloadDisabled}
                        >
                          {lang.download}
                        </LinkButton>
                        <Button
                          class={ThemeButtonLink}
                          disabled={props.isDeleteDisabled || !doc.onDelete}
                          onClick={doc.onDelete}
                          style={{ color: Theme.Color.error }}
                        >
                          {lang.delete}
                        </Button>
                      </div>
                    </td>
                  </tr>
                )}
              />
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
